/**
------------------------------------------------------------------------------
Script: Account Forwards
------------------------------------------------------------------------------
Description:
This script manages account forwarding and UI modifications based on the user's 
login status, cookie state, and specific URL conditions.

Logic:
• Read the user's login status from the <html> data attribute "data-is-logged-in".
• Utility: Provides a function to retrieve cookies by name.
• For logged-in users:
    - If the 'isLoggedIn' cookie is missing, set a 'userIsCustomer' cookie valid for 30 days.
    - Inject CSS to hide specific menu items on all pages.
• Universal:
    - If on the subscription access page, inject CSS to hide the menu items for all users.
• Additional (Salad Pack Builder Logic):
    - On the salad pack builder page (/products/salad-pack-builder) where the URL does NOT include "edit_bundle":
      - If the user is logged in, forward to the account page.
      - If the user is logged out but has the "userIsCustomer" cookie set to "true", forward to the subscription access page.
------------------------------------------------------------------------------
Usage:
- Intended for use Build Your Pack, Account, and Login pages.
------------------------------------------------------------------------------
*/
(function() {
  // Read logged-in status from the <html> data attribute.
  var isLoggedIn = document.documentElement.getAttribute('data-is-logged-in') === 'true';

  // Utility function to get a cookie by name.
  function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }

  if (isLoggedIn) {
    // For logged-in users:
    // If the 'isLoggedIn' cookie doesn't exist, set the 'userIsCustomer' cookie for 30 days.
    if (!getCookie('isLoggedIn')) {
      var days = 30;
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      var expires = "; expires=" + date.toUTCString();
      
      // Set the cookie named "userIsCustomer"
      document.cookie = "userIsCustomer=true" + expires + "; path=/";
      console.log("User is Customer cookie set for 30 days");
    } else {
      console.log("User is logged in!");
    }

    // Inject CSS to hide specific menu items for logged-in users on all pages.
    if (window.location.href != "https://gardencup.com/") {
      var styleEl = document.createElement('style');
      styleEl.textContent = `
        .navlink.navlink--icon {
          margin-right: 0 !important;
        }
        .menu__item[data-nav-item]:first-child,
        .menu__item.menu__item--icon:last-child,
        .mobile-menu__item--index-2 {
          display: none !important;
        }
      `;
      document.head.appendChild(styleEl);
    }

  } else {
    // For logged-out users:
    console.log("User is not logged in.");
  }

  // Universal: Hide menu items for all users if on the subscription access page.
  if (window.location.href === "https://gardencup.com/tools/recurring/get-subscription-access") {
    var styleEl2 = document.createElement('style');
    styleEl2.textContent = `
      .navlink.navlink--icon {
        margin-right: 0 !important;
      }
      .menu__item[data-nav-item]:first-child,
      .menu__item.menu__item--icon:last-child,
      .mobile-menu__item--index-2 {
        display: none !important;
      }
    `;
    document.head.appendChild(styleEl2);
  }

  // Universal: Hide menu items for all users if the userIsCustomer cookie is set to "true".
  if (getCookie('userIsCustomer') === "true") {
    var styleEl = document.createElement('style');
    styleEl.textContent = `
      .navlink.navlink--icon {
        margin-right: 0 !important;
      }
      .menu__item.menu__item--icon:last-child,
      .mobile-menu__item--index-2 {
        display: none !important;
      }
    `;
    document.head.appendChild(styleEl);
  }

  // Additional Logic: On the salad pack builder page (/products/salad-pack-builder)
  // when the URL does NOT include "edit_bundle":
  if (window.location.pathname === "/products/salad-pack-builder" && !window.location.search.includes("edit_bundle")) {
    if (isLoggedIn) {
      // For logged-in users: forward to the account page.
      window.location.href = "https://gardencup.com/account";
    } else if (getCookie('userIsCustomer') === "true") {
      // For logged-out users with the cookie: forward to the subscription access page.
      window.location.href = "https://gardencup.com/tools/recurring/get-subscription-access";
    }
  }
})();
